import { v4 as uuidv4 } from 'uuid';
export const Options = {
    body: {
        id: [],
        type: ['#ms.required'],
        name: ['#ms.required', '#ms.length|max:10'],
        memo: ['#ms.length|max:20'],
        value: ['#ms.required', '#ms.number', '#ms.range|max:999999|min:0'],
        source: ['#ms.required', '#ms.length|max:10'],
        expenditure: ['#ms.required']
    },
    defs: {
        id: () => uuidv4(),
        expenditure: () => true
    },
    inited(self) {
        self.value = Number(self.value);
    },
    list: {
        key: model => model.id
    }
};
